import { useMediaQuery } from "@einride/hooks"
import { Sheets, Stack, useTheme } from "@einride/ui"
import styled from "@emotion/styled"
import { ReactComponent as SidebarSVG } from "assets/drawer.svg"
import { ReactNode } from "react"

export const SIDEBAR_MIN_WIDTH = "5rem"
export const SIDEBAR_WIDTH = "24rem"
export const SIDEBAR_TRANSITION = "0.25s ease-in"

export const DeviceViewContainer = ({
  children,
  isOpen,
  onClose,
}: {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
}): React.JSX.Element => {
  const theme = useTheme()
  const isBelowMd = useMediaQuery(theme.mediaQueries.belowMd)

  if (isBelowMd) {
    return (
      <Sheets isOpen={isOpen} closeHandler={onClose}>
        {children}
      </Sheets>
    )
  }
  return (
    <StackContainer data-testid="sidebar-container" isOpen={isOpen} gap={0} justifyContent="start">
      <Controls>
        <SidebarIcon data-testid="sidebar-icon" onClick={onClose}>
          <SidebarSVG />
        </SidebarIcon>
      </Controls>
      {children}
    </StackContainer>
  )
}

const StackContainer = styled(Stack)<{ isOpen: boolean }>`
  position: relative;
  transition: width ${SIDEBAR_TRANSITION};
  padding: 1.5rem 1rem;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: ${({ isOpen }) => (isOpen ? SIDEBAR_WIDTH : SIDEBAR_MIN_WIDTH)};
  border-left: ${({ theme }) => theme.colors.border.primary} 1px solid;
  overflow-x: hidden;
`

const Controls = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  display: flex;
  justify-content: flex-end;
`

export const SidebarIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  transform: rotate(180deg);
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  :hover {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
`
